
import { EnergyCode } from "@/types";
import { computed, defineComponent } from "vue";

export default defineComponent({
  props: {
    rating: {
      type: Number,
      required: true,
    },
    code: {
      type: String as () => EnergyCode,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    status: {
      type: String as () => "Current" | "Potential" | "Unknown",
      required: true,
    },
  },
  setup(props) {
    const lightColorCodes = new Set(["C", "D", "E"]);

    const textColor = computed(() =>
      lightColorCodes.has(props.code) ? "#4f4f4f" : "white"
    );
    return { textColor };
  },
});
